import React from 'react';
export var Pill = function Pill(_ref) {
  var children = _ref.children,
      pillStyle = _ref.pillStyle;
  return React.createElement("span", {
    style: pillStyle,
    className: pillStyle ? "" : "badge badge-pill badge-dark badge-title-icon"
  }, children);
};